<template>
  <v-container id="home" fluid class="pa-0">
    <v-row no-gutters class="home-row">

      <!-- Left: Search + Rappels -->
      <v-col cols="12" sm="12" md="4" lg="3" xl="3" class="home-col home-col--blue">
        <div class="search-wrapper">
          <Search />
        </div>
        <Rappel />
      </v-col>

      <!-- Center: Devis + Projets (main content) -->
      <v-col cols="12" sm="12" md="8" lg="6" xl="6" class="home-col home-col--white">
        <Devis />
      </v-col>

      <!-- Right: KPIs + Actions -->
      <v-col cols="12" sm="12" md="12" lg="3" xl="3" class="home-col home-col--blue">
        <Chiffres />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import Rappel from "./../components/Home/Rappel";
import Chiffres from "./../components/Home/Chiffres";
import Devis from "./../components/Home/Devis";
import Search from "./../components/Home/Search";

export default {
  name: "home",
  components: {
    Rappel,
    Chiffres,
    Devis,
    Search,
  },
};
</script>

<style lang="scss" scoped>
#home {
  height: 100%;
}

.home-row {
  height: 100%;
}

.home-col {
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.25); border-radius: 4px; }
}

@media screen and (max-width: 960px) {
  .home-row { height: auto; }
  .home-col { height: auto; overflow-y: visible; min-height: 300px; }
  .home-col--white { padding: 12px 16px 0; }
}

.home-col--blue {
  background: linear-gradient(215deg, #0b87ba, #06445d);
  padding-top: 16px;
}

.home-col--white {
  background: #f8f9fb;
  padding: 16px 24px 0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar-thumb { background: #ccc; }
}

.search-wrapper {
  margin-top: 12px;
  padding: 0 12px 12px;
}
</style>
